const actions = {
  SET_STATE: 'settings/SET_STATE',
  CHANGE_SETTING: 'settings/CHANGE_SETTING',
  SET_PRIMARY_COLOR: 'settings/SET_PRIMARY_COLOR',
  SET_THEME: 'settings/SET_THEME',
  SET_LOCALE: 'settings/SET_LOCALE',
  SET_TRANSITION: 'settings/SET_TRANSITION',
}

export default actions
